export default __webpack_public_path__ + "static/media/2021-11-19_15h15_41.528a1b14.jpg";